module.exports = __webpack_public_path__ + "img/__rocket03.2980935e.svg";